import React from 'react';
const stars = Array.from({
  length: 25
}).map((_, i) => ({
  id: i,
  x: Math.random() * 100,
  y: Math.random() * 100,
  size: Math.random() * 2.5 + 1,
  delay: Math.random() * 5,
  duration: Math.random() * 3 + 2,
  opacity: Math.random() * 0.5 + 0.3
}));
export function StarBackground() {
  return <div className="absolute inset-0 overflow-hidden pointer-events-none z-0" data-id="element-543">
      {stars.map(star => <div key={star.id} className="absolute rounded-full bg-white animate-twinkle" style={{
      left: `${star.x}%`,
      top: `${star.y}%`,
      width: `${star.size}px`,
      height: `${star.size}px`,
      animationDelay: `${star.delay}s`,
      animationDuration: `${star.duration}s`,
      opacity: star.opacity
    }} data-id="element-544" />)}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#0a0a1a]/50 to-[#050510] z-0" data-id="element-545" />
    </div>;
}